export const languages = {
  en: "English",
  el: "Ελληνικά",
  fr: "Français",
  es: "Español",
  de: "Deutsch",
  it: "Italiano",
  pt: "Português",
  "pt-br": "Português (Brasil)",
  nl: "Nederlands",
  et: "Eesti",
  tr: "Türkçe",
  ro: "Română",
  ca: "Català",
  lt: "Lietuvių",
  hr: "Hrvatski",
  is: "Íslenska",
  cs: "Čeština",
  da: "Dansk",
  sl: "Slovenščina",
  no: "Norsk",
  pl: "Polski",
  sv: "Svenska",
  fi: "Suomi",
  hu: "Magyar",
  sr: "Српски",
  bg: "Български",
};
export const languageFlags = {
  en: "english",
  el: "greek",
  fr: "french",
  es: "spanish",
  de: "german",
  it: "italian",
  pt: "portuguese",
  "pt-br": "brazilian-portuguese",
  nl: "dutch",
  et: "estonian",
  tr: "turkish",
  ro: "romanian",
  ca: "catalan",
  lt: "lithuanian",
  hr: "croatian",
  is: "icelandic",
  cs: "czech",
  da: "danish",
  sl: "slovenian",
  no: "norwegian",
  pl: "polish",
  sv: "swedish",
  fi: "finnish",
  hu: "hungarian",
  sr: "serbian",
  bg: "bulgarian",
};
